// Ce fichier est auto-généré par `npm run build` (prebuild).
export const APP_VERSION = "2.4.11";
export const BUILD_TIME = "2026-11-02T09:15:22.489Z";
export const ASSET_REV = "2.4.11-1793610922489";
